import React, { ReactNode } from "react"
import { Box } from "@mui/material"
import TableStyleContext from "../TableStyleContext"
import { TableClassesType } from "../Table"
import { useStyles } from "../styles"

type Props = {
  styles: ReturnType<typeof useStyles>
  outerClasses?: Partial<Record<TableClassesType, string>>
  children: ReactNode
}

const TableContainer: React.FC<Props> = ({
  styles,
  outerClasses,
  children
}) => {
  const { classes, cx } = styles

  return (
    <TableStyleContext.Provider value={styles}>
      <Box className={cx(classes.container, outerClasses?.container)}>
        {children}
      </Box>
    </TableStyleContext.Provider>
  )
}

export default TableContainer
